import { render, staticRenderFns } from "./Assistants.vue?vue&type=template&id=3295a9d4&"
import script from "./Assistants.vue?vue&type=script&lang=ts&"
export * from "./Assistants.vue?vue&type=script&lang=ts&"
import style0 from "./Assistants.vue?vue&type=style&index=0&id=3295a9d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports